import Modal from '@mui/material/Modal'
import { useSelector } from 'react-redux'
import { mainSelector } from '../../../redux/slices/main'
import OvalLoader from '../Loaders/OvalLoader'

const LoadingModal = () => {
  const { loading } = useSelector(mainSelector)

  return (
    <Modal open={loading} className="loading_modal modal_wrapper">
      <div className="modal_component">
        <OvalLoader />
      </div>
    </Modal>
  )
}

export default LoadingModal
